var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsrael(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3L24 3L24 20L0 20L0 3Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 4.59375L24 4.59375V7.25L0 7.25L0 4.59375Z",
    fill: "#0038B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 15.75L24 15.75V18.4063L0 18.4062L0 15.75Z",
    fill: "#0038B8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 7.82031L13.0907 9.66062L15.2725 9.66062L14.1816 11.5009L15.2725 13.3412H13.0907L11.9998 15.1815L10.9089 13.3412H8.72705L9.81796 11.5009L8.72705 9.66062H10.9089L11.9998 7.82031ZM10.5625 10.245H9.76628L10.1644 10.9165L10.5625 10.245ZM10.5108 11.5009L11.2553 10.245H12.7443L13.4888 11.5009L12.7443 12.7568H11.2553L10.5108 11.5009ZM10.1644 12.0853L9.76628 12.7568H10.5625L10.1644 12.0853ZM11.6017 13.3412L11.9998 14.0128L12.3979 13.3412H11.6017ZM13.4371 12.7568H14.2333L13.8352 12.0853L13.4371 12.7568ZM13.8352 10.9165L14.2333 10.245H13.4371L13.8352 10.9165ZM12.3979 9.66062H11.6017L11.9998 8.98906L12.3979 9.66062Z",
    fill: "#0038B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsrael);
export default __webpack_public_path__ + "static/media/israel.f05ed473ca7edf71006be745adaec4fe.svg";
export { ForwardRef as ReactComponent };